import React from 'react';
// styles
import styled from 'styled-components';

const AnalyticsIcon = ({ className, ...props }) => (
  <svg
    {...props}
    role="img"
    aria-label="Analytics"
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.2333 6.7002H8.76662C7.62995 6.7002 6.69995 7.6302 6.69995 8.76686V23.2335C6.69995 24.3702 7.62995 25.3002 8.76662 25.3002H23.2333C24.37 25.3002 25.2999 24.3702 25.2999 23.2335V8.76686C25.2999 7.6302 24.37 6.7002 23.2333 6.7002ZM11.8666 21.1669C11.2983 21.1669 10.8333 20.7019 10.8333 20.1335V17.0335C10.8333 16.4652 11.2983 16.0002 11.8666 16.0002C12.435 16.0002 12.9 16.4652 12.9 17.0335V20.1335C12.9 20.7019 12.435 21.1669 11.8666 21.1669ZM16 21.1669C15.4316 21.1669 14.9666 20.7019 14.9666 20.1335V19.1002C14.9666 18.5319 15.4316 18.0669 16 18.0669C16.5683 18.0669 17.0333 18.5319 17.0333 19.1002V20.1335C17.0333 20.7019 16.5683 21.1669 16 21.1669ZM16 16.0002C15.4316 16.0002 14.9666 15.5352 14.9666 14.9669C14.9666 14.3985 15.4316 13.9335 16 13.9335C16.5683 13.9335 17.0333 14.3985 17.0333 14.9669C17.0333 15.5352 16.5683 16.0002 16 16.0002ZM20.1333 21.1669C19.5649 21.1669 19.1 20.7019 19.1 20.1335V11.8669C19.1 11.2985 19.5649 10.8335 20.1333 10.8335C20.7016 10.8335 21.1666 11.2985 21.1666 11.8669V20.1335C21.1666 20.7019 20.7016 21.1669 20.1333 21.1669Z"
      fill="#E2E8EE"
    />
  </svg>
);

export default styled(AnalyticsIcon)``;
